export enum AddressClass {
  ROAD = 'ROAD',
  JIBUN = 'JIBUN',
}
